import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00c3e9e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pagination c-thirdary"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }

import { reactive, watchEffect, withDefaults, computed } from 'vue';
import i18, { State as I18State } from '@/store/i18';
import { useStore } from 'vuex';

interface Props {
    total?: number,
    page?: number,
    size?: number,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    total: { default: 1 },
    page: { default: 0 },
    size: { default: 20 }
  },
  emits: ["change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'change', page: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { total: number, page: number, size: number }

const store = useStore()
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].common)






const state = reactive<{
    totalPages: number,
    pages: number[],
}>({ pages: [], totalPages: 0 })

watchEffect(update)

function update() {
    state.totalPages = Math.ceil(props.total / props.size)
    let arr = [props.page - 2, props.page - 1, props.page, props.page + 1, props.page + 2]
    if (arr[0] < 0) {
        arr = arr.map(n => n - arr[0])
    }
    if (arr[4] > state.totalPages - 1) {
        arr = arr.map(n => n - arr[4] + state.totalPages - 1)
    }
    state.pages = arr.filter(n => n >= 0)
}

function goFirst() {
    go(0)
}

function goPrev() {
    if (props.page > 0) {
        go(props.page - 1)
    }
}

function goNext() {
    if (props.page < state.totalPages - 1) {
        go(props.page + 1)
    }
}

function goEnd() {
    go(state.totalPages - 1)
}

function go(page: number) {
    if (props.page != page) {
        emits('change', page);
    }
}


return (_ctx: any,_cache: any) => {
  return (__props.total > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          class: _normalizeClass({ disabled: __props.page == 0 }),
          onClick: goFirst
        }, _toDisplayString(_unref(lang).first_page), 3),
        _createElementVNode("a", {
          class: _normalizeClass({ disabled: __props.page == 0 }),
          onClick: goPrev
        }, _toDisplayString(_unref(lang).prev_page), 3),
        (_unref(state).totalPages > 5 && _unref(state).pages[0] > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "..."))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).pages, (i) => {
          return (_openBlock(), _createElementBlock("a", {
            class: _normalizeClass(["no", { on: i == __props.page }]),
            onClick: ($event: any) => (go(i))
          }, _toDisplayString(i + 1), 11, _hoisted_3))
        }), 256)),
        (_unref(state).totalPages > 5 && _unref(state).pages[_unref(state).pages.length - 1] < _unref(state).totalPages - 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "..."))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          class: _normalizeClass({ disabled: __props.page == _unref(state).totalPages - 1 }),
          onClick: goNext
        }, _toDisplayString(_unref(lang).next_page), 3),
        _createElementVNode("a", {
          class: _normalizeClass({ disabled: __props.page == _unref(state).totalPages - 1 }),
          onClick: goEnd
        }, _toDisplayString(_unref(lang).last_page), 3)
      ]))
    : _createCommentVNode("", true)
}
}

})